import BaseModule from '@/store/baseModule';
import serviceAPI from '../../../services/services/technicians.service';

const attributesObjRef = {
  position: {
    serverSide: true,
    values: [
      { id: 'Technicien', name: 'Technicien' },
      { id: 'Sous-traitant', name: 'Sous-traitant' },
      { id: 'Responsable Unité', name: 'Responsable Unité' },
      { id: 'Autre', name: 'Autre' },
    ],
  },
  entity_nav_full_id: {
    type: '$instr',
    serverSide: true,
    values: [],
  },
};

const attributesObj = {
  entity_nav_full_id: {
    type: '$instr',
    serverSide: true,
    values: [],
  },
};

export default ({ makeListRequest, obsoleteAllowed }) =>
  new BaseModule({
    attributesObjRef,
    attributesObj,
    sortChoices: ['full_name'],
    defaultASC: [true],
    serviceAPI,
    pageSizeIndex: 4,
    makeQueryParams: makeListRequest({
      dateField: 'end_date',
      obsoleteAllowed,
      useEntities: true,
    }),
  });
